import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, StarIcon } from 'lucide-react';
import { volumes } from '../data/volumes';
import { FlowLine } from './FlowLine';
import { Ornament } from './Ornament';
export function TomosSection() {
  return <section className="border-t border-gold/20 bg-white px-4 py-20 sm:py-28" data-id="element-325" data-mp="1p5n4w5lrnqmv">
      <div className="mx-auto max-w-6xl" data-id="element-326" data-mp="1u258311g7gx3">
        <div className="mx-auto max-w-3xl text-center" data-id="element-327" data-mp="xce3g8zg0ddk">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-burgundy" data-id="element-328" data-mp="xdyw1t275m8s">
            The 6 volumes
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-ink sm:text-4xl" data-id="element-329" data-mp="11fsrnmxjc023">
            The <span className="italic text-burgundy" data-id="element-330" data-mp="16breh637ta0e">6-Volume</span> Salsa &
            Bachata Instructor System
          </h2>
          <Ornament className="mt-5" data-id="element-331" data-mp="2hs7v32qi9wou" />
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-332" data-mp="2hrg1tykdsb1q">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex h-full flex-col rounded-xl border bg-cream p-6 shadow-soft sm:p-8 ${volume.badge ? 'border-gold/70' : 'border-gold/25'}`} data-id="element-333" data-mp="2mpra44v12dhu" data-mpi={index}>
              <div className="flex items-center justify-between gap-3" data-id="element-334" data-mp="22yo2j586z3bh">
                <p className="font-display text-sm font-semibold uppercase tracking-[0.16em] text-burgundy" data-id="element-335" data-mp="22xctoqzw35di">
                  {volume.number}
                </p>
                {volume.badge && <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-gold bg-wine px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-cream" data-id="element-336" data-mp="1tvv7qrzsw9gw">
                    <StarIcon size={12} className="text-champagne" fill="currentColor" aria-hidden="true" data-id="element-337" data-mp="1k1v5qyztfkce" />
                    {volume.badge}
                  </span>}
              </div>
              <span className="mt-3 block h-px w-12 bg-gold" aria-hidden="true" data-id="element-338" data-mp="11duhetuikpyv" />
              <h3 className="mt-4 text-2xl font-semibold leading-snug text-ink" data-id="element-339" data-mp="15dcyfej7sgwf">
                {volume.title}
              </h3>
              <p className="mt-3 border-l-2 border-gold pl-4 text-sm font-medium leading-6 text-burgundy" data-id="element-340" data-mp="1y1h96egn7k5z">
                {volume.subtitle}
              </p>
              <div className="mt-6" data-id="element-341" data-mp="1ka3qf2qk6qc0">
                {volume.problem.map((paragraph, pIndex) => <p key={paragraph} className={`text-sm leading-6 text-ink-muted ${pIndex > 0 ? 'mt-2' : ''}`} data-id="element-342" data-mp="1oa4hpnyraw0h" data-mpi={pIndex}>
                    {paragraph}
                  </p>)}
              </div>
              {volume.extraList && <ChecklistBlock label={volume.extraList.label} items={volume.extraList.items} data-id="element-343" data-mp="5bgdawhlqfiy" />}
              <div className="mt-6" data-id="element-344" data-mp="f216g4eiaruh">
                <p className="text-sm font-semibold text-ink" data-id="element-345" data-mp="f2b1i6eerp71">
                  {volume.listLabel}
                </p>
                <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-346" data-mp="3ijt521n5ea1n">
                  {volume.bullets.map(bullet => <li key={bullet} className="rounded-full border border-gold/30 bg-white px-2.5 py-1 text-xs font-medium text-ink" data-id="element-347" data-mp="3dkyci7zdp74c">
                      {bullet}
                    </li>)}
                </ul>
              </div>
              {volume.highlight && <ChecklistBlock label={volume.highlight.label} items={volume.highlight.items} data-id="element-348" data-mp="17px173kim9om" />}
              {volume.flow && <FlowLine className="mt-6" label={volume.flow.label} steps={volume.flow.steps} data-id="element-349" data-mp="38is4zl7vrm6n" />}
              <div className="mt-auto pt-7" data-id="element-350" data-mp="3hgudelty1h3y">
                <div className="rounded-lg border border-gold/30 bg-beige/60 p-4 text-sm leading-6 text-ink" data-id="element-351" data-mp="3mgp3wo9t44oh">
                  <strong className="font-semibold text-burgundy" data-id="element-352" data-mp="3rg1ot3h4b1of">
                    Result:{' '}
                  </strong>
                  {volume.result.join(' ')}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function ChecklistBlock({
  label,
  items
}: {
  label: string;
  items: string[];
}) {
  return <div className="mt-5" data-id="element-353" data-mp="93n6ec62cv7r">
      <p className="text-sm font-semibold text-ink" data-id="element-354" data-mp="e1f2zjhnl5ia">{label}</p>
      <ul className="mt-2 grid gap-x-4 gap-y-1.5 sm:grid-cols-2" data-id="element-355" data-mp="dz2dml9kfsv7">
        {items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-6 text-ink-muted" data-id="element-356" data-mp="ixnfep4guklr">
            <CheckIcon size={16} className="mt-1 shrink-0 text-gold" aria-hidden="true" data-id="element-357" data-mp="t583qs2g1jm1" />
            {item}
          </li>)}
      </ul>
    </div>;
}